import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../config/firebase';

const ForgottenPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Email de réinitialisation de mot de passe envoyé.!');
            setError('');
        } catch (error) {
            setError(error.message);
            setMessage('');
        }
    };

    return (
        <div className="contact-wrapper overflow-hidden">
            <div className="container pt-120 position-relative">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="contact-form-wrapper">
                            <h4 className="contact-form-title">Mot de passe oublié</h4>
                            <form onSubmit={handlePasswordReset}>
                                <div className="primary-input-group">
                                    <input
                                        type="email"
                                        id="email"
                                        placeholder="Entrez votre email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                {message && <p className="message">{message}</p>}
                                {error && <p className="error">{error}</p>}
                                <div className="submit-btn">
                                    <button type="submit" className="mt-4 btn primary-submit">
                                        Réinitialiser votre mot de passe
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ForgottenPassword;